import * as Yup from 'yup';

import { ResolvableModeEnum } from '@e-socna/data-layer';
import { isDefined } from '@e-socna/utils';

export const ResolvableIdSchema = Yup.object()
  .shape({
    mode: Yup.mixed<ResolvableModeEnum>()
      .oneOf(Object.values(ResolvableModeEnum))
      .required('Le mode est requis'),
    resolverId: Yup.string().optional().nullable(),
    value: Yup.string().optional().nullable(),
  })
  .test({
    name: 'is-valid',
    // eslint-disable-next-line object-shorthand
    test: function (values) {
      if (
        (values.mode === ResolvableModeEnum.Static &&
          isDefined(values.value) &&
          !isDefined(values.resolverId)) ||
        (values.mode === ResolvableModeEnum.Dynamic &&
          !isDefined(values.value) &&
          isDefined(values.resolverId))
      ) {
        return true;
      }

      return this.createError({
        message:
          'Veuillez sélectionner un mode et fournir une valeur ou un résolveur valide.',
      });
    },
  });
